// extracted by mini-css-extract-plugin
export default {"title":"style_title__1WwuR","container":"style_container__wAeJ-","description":"style_description__J_yv9"};